import * as React from 'react';

function SvgCaretDownIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 9.17a1 1 0 00-1.41 0L12 12.71 8.46 9.17a1 1 0 10-1.41 1.42l4.24 4.24a1.002 1.002 0 001.42 0L17 10.59a1.002 1.002 0 000-1.42z"
        fill="#7987A3"
      />
    </svg>
  );
}

export default SvgCaretDownIcon;
